<template>
  <tr class="border-b border-gray-300 hover:bg-gray-50">
    <td class="bg-white py-2">
      <ProductCard :item="item" />
    </td>
    <ProductQuantityCell
      v-for="date in dates"
      :key="date"
      :date="date"
      :item="item" />
  </tr>
</template>

<script>
import ProductCard from './ProductCard'
import ProductQuantityCell from './ProductQuantityCell'

export default {
  name: 'ProductRow',
  components: {
    ProductQuantityCell,
    ProductCard
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    dates: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.info-row > span:not(:last-child):after {
  content: ", ";
}
</style>
